import skeleton_module_default from "./skeleton.module.js";
import { Skeleton } from "@mantine/core";
import { jsx } from "react/jsx-runtime";

//#region src/components/skeleton/Skeleton.tsx
const Skeleton$1 = ({ circle = false, height, width, children, visible = true, "data-testid": testId = "skeleton" }) => {
	return /* @__PURE__ */ jsx(Skeleton, {
		"data-testid": testId,
		visible,
		circle,
		height,
		width,
		classNames: skeleton_module_default,
		children
	});
};

//#endregion
export { Skeleton$1 as Skeleton };